<template>
  <IQOS :title="$t('menu_settings.systems')" required v-if="showBlockAtAll">
    <div v-for="(m) in mode_names" :key="m">
      <IQOSModeToggle
        :mode="m"
        class="mt-8"
        :value="dish.enabled_modes[m]"
        @input="onToggle(m)"
        v-if="availableModes[m]"
      >
        {{ m.toUpperCase() }}
      </IQOSModeToggle>
    </div>
    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("dish_settings.enable_modes_description") }}
    </p>
  </IQOS>
</template>

<script>

export default {
  data() {
    return {
      mode_names: ["inside", "preorder", "delivery", "hotels"],
    };
  },
  methods: {
    onToggle(mode) {
      this.$store.commit("menu/toggleProductMode", {
        mode,
      });
      this.$store.dispatch("menu/updateProduct");
    },
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    menu() {
      return this.$store.state.menu.current;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    availableModes() {
      return {
        inside: this.cafe.menu_ids.includes(this.menu._id),
        preorder: this.cafe.preorder.menu_ids.includes(this.menu._id),
        delivery: this.cafe.delivery.menu_ids.includes(this.menu._id),
        hotels: this.cafe.hotels.menu_ids.includes(this.menu._id),
      };
    },
    showBlockAtAll() {
      return (
        this.availableModes.inside ||
        this.availableModes.preorder ||
        this.availableModes.delivery ||
        this.availableModes.hotels
      );
    },
  },
  components: {
  },
};
</script>

<style scoped>
</style>